import React from 'react';
import { Clock, Search, FileText, BarChart3, Zap } from 'lucide-react';

const activities = [
  {
    type: 'optimization',
    icon: Zap,
    title: 'AISO optimoi sisältöä',
    description: '"Parhaat kahvinkeittotavat" artikkeli optimoitiin',
    time: '2 minuuttia sitten',
    color: 'purple',
  },
  {
    type: 'ranking',
    icon: BarChart3,
    title: 'Seeding tekniikan mahdollisuus havaittu',
    description: '"Espressokone" mahdollisuus nousta vastauksesi',
    time: '15 minuuttia sitten',
    color: 'green',
  },
  {
    type: 'keyword',
    icon: Search,
    title: 'Uusia hakulauseita löydetty',
    description: '3 uutta potentiaalisesti kannattavaa hakulausetta',
    time: '1 tunti sitten',
    color: 'blue',
  },
  {
    type: 'content',
    icon: FileText,
    title: 'Sisältöehdotus valmis',
    description: '"Kahvin säilytys" aiheesta luotu sisältösuunnitelma',
    time: '2 tuntia sitten',
    color: 'orange',
  },
];

const colorMap: { [key: string]: string } = {
  purple: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
  green: 'bg-green-500/20 text-green-400 border-green-500/30',
  blue: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  orange: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
};

export default function RecentActivity() {
  return (
    <div className="bg-slate-800/50 backdrop-blur-xl rounded-xl p-6 border border-slate-700/50">
      <div className="flex items-center space-x-2 mb-6">
        <Clock className="w-5 h-5 text-slate-400" />
        <h3 className="text-lg font-bold text-white">Viimeisimmät toimenpide ehdotukset</h3>
      </div>

      <div className="space-y-4">
        {activities.map((activity, index) => {
          const Icon = activity.icon;
          
          return (
            <div
              key={index}
              className="flex items-start space-x-4 p-4 rounded-lg bg-slate-700/20 border border-slate-600/20 hover:border-slate-500/30 hover:bg-slate-700/30 transition-all duration-200 group cursor-pointer"
            >
              <div className={`w-10 h-10 rounded-lg border flex items-center justify-center ${colorMap[activity.color]}`}>
                <Icon className="w-5 h-5" />
              </div>
              
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-semibold text-white group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-white group-hover:to-slate-300 transition-all duration-300">
                  {activity.title}
                </h4>
                <p className="text-sm text-slate-300 mt-1 leading-relaxed">
                  {activity.description}
                </p>
                <div className="flex items-center justify-between mt-2">
                  <span className="text-xs text-slate-400">{activity.time}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-6 pt-4 border-t border-slate-700/50">
        <button className="text-sm text-purple-400 hover:text-purple-300 font-medium transition-colors duration-200">
          Näytä kaikki  →
        </button>
      </div>
    </div>
  );
}
